// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"css-2_VKGCH7eZ","page__closed":"css-3_K_capNtP","page__textPage":"css-25EaLVk8t3","page__start":"css-_NQ92KR5Sh"};